module.exports = __webpack_public_path__ + "media/images/emoticons/sign04-fe84872af9a8f011637921c8400f7b2b.gif";